import type {
  LimitOrderReloadFormRequest,
  LimitOrderReloadFormResponse,
  LimitOrderResponse,
} from 'apiConnector/secondary-market/limit-order/models';
import type { ClientOrRelativesRequest, ClientOrRelativesResponse } from 'apiConnector/secondary-market/shared/clients';
import type { SettlementDateResponse } from 'apiConnector/secondary-market/shared/settlement';
import type { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import type { ClientType } from 'state/secondaryMarket/shared/form.models';
import type { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface LimitOrderGetOrderByIdApi {
  getOrderById(orderId: string): Observable<LimitOrderResponse>;
}

export interface LimitOrderInitFormApi {
  init(request: LimitOrderReloadFormRequest): Observable<LimitOrderReloadFormResponse>;
}

export interface LimitOrderClientFormApi {
  interactClient(request: ClientOrRelativesRequest): Observable<ClientOrRelativesResponse>;
}

export interface LimitOrderSettlementDateApi {
  getSettlementDate(
    key: BcsProductKey,
    counterpartyEliotId: string | undefined,
    clientType: ClientType | undefined,
  ): Observable<SettlementDateResponse>;
}

export function limitOrderFormApiConnector(
  httpClient: IHttpClient,
): LimitOrderInitFormApi & LimitOrderClientFormApi & LimitOrderGetOrderByIdApi & LimitOrderSettlementDateApi {
  return {
    getOrderById: (orderId: string) => {
      return httpClient
        .getJSON<LimitOrderResponse>({
          url: `api/v1/secondary-market/limit-order?orderId=${encodeURIComponent(orderId)}`,
          tryParseErrorPayload: true,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    init: request => {
      return httpClient
        .postJSON<LimitOrderReloadFormResponse>({
          url: 'api/v1/secondary-market/limit-order/forms/init',
          body: request,
          tryParseErrorPayload: true,
          parseErrorPayload: true,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    interactClient: request => {
      return httpClient
        .postJSON<ClientOrRelativesResponse>({
          url: 'api/v1/secondary-market/limit-order/client',
          body: request,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    getSettlementDate(key, counterpartyEliotId, clientType) {
      return httpClient
        .getJSON<SettlementDateResponse>({
          url: `api/v1/secondary-market/limit-order/settlement-date`,
          params: {
            bcsSource: key.source,
            bcsSubType: key.subType,
            bcsCode: key.code,
            counterpartyEliotId,
            clientType,
          },
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
